import { PickerMode } from '@gripp/shared-logic';
import { useEffect, useRef } from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { Colors } from '../../themes/colors';
import { MobileIcon } from '../crop-circle/icons';
import { RenderMediaItem } from './renderMediaItem';
import { MediaGalleryProps } from './types';
import { useTypedMedia } from './useTypedMedia';

export const HorizontalMediaGallery = (props: MediaGalleryProps) => {
  const { handleAdd, handleUploadProgress, typedMedia, handleDelete } =
    useTypedMedia(props.media);
  const MediaPicker = props.mediaPicker;
  const scrollRef = useRef<ScrollView>(null);
  const canAddMedia = props.canAddMedia ?? true;
  const pickerMode =
    props.pickerMode === 'picker' ? PickerMode.PICKER : PickerMode.CAMERA;

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollToEnd({ animated: true });
    }
  }, [typedMedia?.length]);

  return (
    <View style={styles.containerCropCircle}>
      {typedMedia.length > 0 && (
        <ScrollView
          ref={scrollRef}
          horizontal={true}
          showsHorizontalScrollIndicator={true}
          scrollEnabled={true}
          contentContainerStyle={styles.scrollContentCropCircle}
          style={styles.scrollViewCropCircle}
        >
          {typedMedia.map((m) => (
            <View style={styles.mediaItemContainer} key={m.id}>
              <RenderMediaItem
                mediaItem={m}
                key={m.id}
                canDelete={props.canEditMedia}
                deleteMediaItem={(mediaId) =>
                  handleDelete(mediaId, props.onMediaDeleted)
                }
              />
            </View>
          ))}
        </ScrollView>
      )}
      {canAddMedia && (
        <MediaPicker
          workspaceId={props.workspaceId}
          setMedia={(media) => handleAdd(media, props.onMediaAdded)}
          mode={pickerMode}
          setProgress={handleUploadProgress}
          setUploading={props.onUploadingChanged}
          style={[styles.pickerCropCircle, props.pickerMarginTop !== undefined && { marginTop: props.pickerMarginTop }]}
          acceptedMediaTypes={props.acceptedMediaTypes}
          customTrigger={
            <View style={[styles.pickerCropCircle, props.pickerMarginTop !== undefined && { marginTop: props.pickerMarginTop }]}>
              <MobileIcon size={32} color={Colors.role.textStrong} />
            </View>
          }
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  containerCropCircle: {
    flexDirection: 'row',
    display: 'flex',
  },
  scrollViewCropCircle: {
    flexGrow: 0,
    flexShrink: 1,
  },
  scrollContentCropCircle: {
    alignItems: 'center',
  },
  pickerCropCircle: {
    height: 88,
    width: 88,
    borderRadius: 4,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: Colors.role.surfaceHover,
    marginTop: 12,
  },
  mediaItemContainer: {
    marginLeft: 8,
    marginRight: 2,
  },
});
